/**
 * For teaching resources only. Get all h2 on page, extract the ID+text, populate menu.
 */
export const initAnchorMenu = () => {
  const anchorMenu = document.getElementById('anchor-menu-list'); // Get the anchor menu <ul>.
  if (anchorMenu?.parentElement.id !== 'teaching-resource-aside') return; // Check that we're in teaching resource page

  const elements = [...document.querySelectorAll('h2:not(.visually-hidden)')]; // Get all VISIBLE H2 on page.
  // For each, create <li> with id, title, class. Append to menu.
  for (let i = 0; i < elements.length; i++) {
    const li = document.createElement('li');
    li.className = 'anchor-menu__link text-small';
    li.style = `--delay:${i * 150 + 200}ms;`; // nice animation delay 😎
    li.innerHTML = `<a href="#${elements[i].id}">${elements[i].innerHTML}</a>`;
    anchorMenu.appendChild(li);
  }
};
export default 'initAnchorMenu';
